import React from "react";
import { Alert } from "antd";
import { AlertProps } from "types";
import Linkify from "react-linkify";

type TProps = {
  errors: AlertProps[];
  onClose: (index: number) => void;
};

const ErrorAlerting = ({ errors, onClose }: TProps) => {
  const linkifyText = (desc: any) => <Linkify>{desc}</Linkify>;

  return (
    <>
      {errors.map((error, index) => (
        <Alert
          // There's nothing unique about errors, so using index as key here
          // eslint-disable-next-line react/no-array-index-key
          key={`#${index}:${error.title}`}
          className="alert"
          message={linkifyText(error.title)}
          description={linkifyText(error.description)}
          type="error"
          closable
          onClose={() => onClose(index)}
          showIcon
        />
      ))}
    </>
  );
};

export default ErrorAlerting;
